module.exports = __webpack_public_path__ + "static/media/List_VIOLIN.26abd67f.mp3";